module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-500-latin-ext5.c1506c7.woff2";